<template>
  <div>
    <div>
      <el-page-header @back="goBack" content="班级成绩分析" style="margin-bottom: 10px">
      </el-page-header>
    </div>

    <div>
      <span class="student_name">{{this.classId}}</span>
      <span class="marl_10 student_subject" v-if="this.subname!==''">{{this.subname}}</span>

      <span>历史成绩分析</span>
    </div>
    <div style="margin: 10px 0">
      <!-- 折线图 -->
      <div class="chart" id="chart">

      </div>
    </div>
    <el-table border :data="tableData" stripe style="width: 100%">
      <el-table-column label="序号">
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column prop="name" label="考试">
      </el-table-column>
      <el-table-column prop="avgScore" label="班级平均成绩">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <i class="el-icon-search" @click="handleEdit(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="班级成绩明细" :visible.sync="dialogTableVisible" width="80%">
      <div style="margin: 10px 0">
        <el-row>
          <el-col :span="12"><b>考试：{{this.teacherClassTitle.name}} </b></el-col>
          <el-col :span="6"><b>考试时间：{{this.teacherClassTitle.time}} </b></el-col>

        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="12"> <b>班级：{{this.teacherClassTitle.grade_class}}</b></el-col>
        </el-row>
      </div>
      <el-table :data="teacherClassDetails">
        <el-table-column label="#">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="考生">
        </el-table-column>
        <el-table-column prop="begin_dt" label="考试时间">
        </el-table-column>
        <el-table-column prop="score" label="成绩">
        </el-table-column>
        <el-table-column prop="time" label="耗时">
        </el-table-column>
        <el-table-column prop="tname" label="评价老师">
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
    export default {
        data() {
            return {
                total: 0,
                classId: '',
                subname: '',
                dialogType: 'new',
                dialogTableVisible: false,
                teacherClassDetails: [],
                teacherClassTitle: {},
                tableData: [],
                examInfo: {},
                listQuery: {
                    page: 1,
                    per_page: 20
                },
            };
        },
        computed: {},
        mounted() {
            this.getData();
            window.addEventListener('resize', () => {
                this.$echarts.init(document.getElementById('chart')).resize()
            })
        },
        methods: {
            goBack() {
                this.$router.back();
            },
            getData() {
                this.$http.teacherClassAnalysis(this.$route.query)
                    .then(res => {
                        this.tableData = res.data.datalist;
                        this.classId = res.data.classId;
                        this.subname = res.data.subname;
                        const examName = res.data.nameData.split(",");
                        const scoreAll = res.data.allData.split(",");
                        const scoreAvg = res.data.classData.split(",");
                        this.getline(examName,scoreAll,scoreAvg)
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
                const params={
                    examid:this.$route.query.exam_id,
                    subject: 1,
                    classid: this.classId,
                    subid:this.$route.query.subject_id,
                };
                this.$http.teacherClassDetail(params).then(res=>{
                    this.teacherClassDetails=res.data.datalist;
                    this.teacherClassTitle=res.data.data;
                    this.dialogTableVisible=true
                })
            },
            //构建图标
            getline(examName,scoreAll,scoreAvg) {
                let chart = this.$echarts.init(document.getElementById('chart'))
                // 绘制图表
                chart.setOption({
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        orient: 'horizontal', // 'vertical'
                        x: 'right', // 'center' | 'left' | {number},
                        y: 0, // 'center' | 'bottom' | {number}
                        padding:40,
                        data: ["得分","平均分"]
                    },
                    calculable: false,
                    xAxis: [{
                        type: "category",
                        boundaryGap: !1,
                        data:examName
                    }],
                    yAxis: [{
                        type: "value",
                        axisLabel: {
                            formatter: "{value}"
                        }
                    }],
                    series: [{
                        name: "得分",
                        type: "line",
                        data: scoreAll,
                        markPoint: {
                            data: [{
                                type: "max",
                                name: "最大值"
                            },
                                {
                                    type: "min",
                                    name: "最小值"
                                }]
                        }
                    },{
                        name: "平均分",
                        type: "line",
                        data: scoreAvg,
                        markPoint: {
                            data: [{
                                type: "max",
                                name: "最大值"
                            },
                                {
                                    type: "min",
                                    name: "最小值"
                                }]
                        }
                    }]
                });
            }
        },
    };
</script>

<style scoped lang="less">
  .chart {
    width: 100%;
    height: 300px;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/teacherClassDetail.vue